export function getUserRole() {
  return localStorage.getItem('role_name');
}

export function isMR() {
  const role = getUserRole();
  return role === 'MR' || role === '销售';
}

export function isGBA() {
  const role = getUserRole();
  return role === 'GBA' || role === 'GA';
}

export function isSalesManagerTerritory(territoryType = getLocalStorage('territory_type')) {
  return ['DM', 'AM', 'SD'].includes(String(territoryType || '').toUpperCase());
}

// 判断当前登录用户是否有权限查看 KDM 标记
// 规则：role_id 为 12（GBA），或 role_id 为 2（销售）且 territory_type 为 DM
export function hasKdmPermission(
  roleId = getLocalStorage('role_id'),
  territoryType = getLocalStorage('territory_type')
) {
  const id = String(roleId || '');
  const territory = String(territoryType || '').toUpperCase();
  if (id === '12') return true;
  if (id === '2' && territory === 'DM') return true;
  return false;
}

// 将 is_kdm 字段统一规范化为布尔值，兼容 bool / 数字 / 字符串类型
export function isKdmTrue(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'y'].includes(value.trim().toLowerCase());
  }
  return false;
}

export function isSpecialSalesOverviewRole(roleId = getLocalStorage('role_id'), roleName = getLocalStorage('role_name')) {
  const id = String(roleId || '');
  const name = String(roleName || '');
  return ['1', '3', '11'].includes(id) || ['管理员', '市场部', 'RPM'].includes(name);
}

export function normalizeSalesOverviewContext(context = {}) {
  if (!isSpecialSalesOverviewRole(context.role_id, context.role_name)) return context;
  const roleId = String(context.role_id || '');
  const roleName = String(context.role_name || '');
  if (roleId === '11' || roleName === 'RPM') {
    return {
      ...context,
      territory_id: context.territory_id || '',
      territory_type: 'AM',
      simulated_sales_overview: '1',
    };
  }
  return {
    ...context,
    territory_id: context.territory_id || 'SD',
    territory_type: 'SD',
    simulated_sales_overview: '1',
  };
}

export function normalizeEnableAI(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'y'].includes(value.trim().toLowerCase());
  }
  return false;
}

export function resolveEnableAI(value, roleId = getLocalStorage('role_id'), roleName = getLocalStorage('role_name')) {
  const isSalesRole = String(roleId) === '2' || (!roleId && (roleName === '销售' || roleName === 'MR'));
  return isSalesRole ? normalizeEnableAI(value) : true;
}

export function isEnableAI() {
  return resolveEnableAI(getLocalStorage('enable_ai'));
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = () => {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return (...args) => {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}
export function settPageData(pageArr, pageSize) {
  let arrLength = pageArr.length;
  let num = pageSize;
  let index = 0;
  let newArr = [];
  for (let i = 0; i < arrLength; i++) {
    if (i % num === 0 && i !== 0) {
      newArr.push(pageArr.slice(index, i));
      index = i;
    }
    if ((i + 1) === arrLength) {
      newArr.push(pageArr.slice(index, i + 1));
    }
  }

  return newArr;
}
// adopt from https://ruby-china.org/topics/29026
export function chineseToEnglish(c) { // 中文转拼音
  var idx = -1;
  var MAP = 'ABCDEFGHJKLMNOPQRSTWXYZ';
  var boundaryChar = '驁簿錯鵽樲鰒餜靃攟鬠纙鞪黁漚曝裠鶸蜶籜鶩鑂韻糳';
  if (!String.prototype.localeCompare) {
    throw Error('String.prototype.localeCompare not supported.');
  }
  if (/[^\u4e00-\u9fa5]/.test(c)) {
    return c;
  }
  for (var i = 0; i < boundaryChar.length; i++) {
    if (boundaryChar[i].localeCompare(c, 'zh-CN-u-co-pinyin') >= 0) {
      idx = i;
      break;
    }
  }
  return MAP[idx];
}

export function getFirstUpperChar(str) {
  let string = String(str);
  var c = string[0];
  if (/[^\u4e00-\u9fa5]/.test(c)) {
    return c.toUpperCase();
  } else {
    return chineseToEnglish(c);
  }
}

export function reverseByKey(key) {
  return (a, b) => {
    const val1 = a[key];
    const val2 = b[key];
    return val2 - val1;
  };
}

export function LightenDarkenColor(col, amt) {
  var usePound = false;
  if (col[0] === '#') {
    col = col.slice(1);
    usePound = true;
  }
  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) {
    r = 255;
  } else if (r < 0) {
    r = 0;
  }
  var b = ((num >> 8) & 0x00FF) + amt;
  if (b > 255) {
    b = 255;
  } else if (b < 0) {
    b = 0;
  }
  var g = (num & 0x0000FF) + amt;
  if (g > 255) {
    g = 255;
  } else if (g < 0) {
    g = 0;
  }
  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
}

export function findIndex(ary, fn) {
  if (ary.findIndex) {
    return ary.findIndex(fn);
  }
  /* istanbul ignore next */
  let index = -1;
  /* istanbul ignore next */
  ary.some((item, i, ary) => {
    const ret = fn.call(this, item, i, ary);
    if (ret) {
      index = i;
      return ret;
    }
  });
  /* istanbul ignore next */
  return index;
}
export function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

export function getLocalStorage(key) {
  return window.localStorage.getItem(key);
}

export function removeLocalStorage(key) {
  return window.localStorage.removeItem(key);
}

export function removeAllLocalStorage() {
  return window.localStorage.clear();
}

export function clearManagerOverviewPeriodState() {
  const prefix = 'manager_overview_period_state';
  const keys = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (key && key.indexOf(prefix) === 0) {
      keys.push(key);
    }
  }
  keys.forEach(key => window.localStorage.removeItem(key));
}
export function filterNull(arr) {
  let tArr = [];
  arr.forEach(ele => {
    if (ele) {
      tArr.push(ele);
    }
  });
  return tArr;
}

export function getURLParams(url) {
  let paramResult = {};
  if (url.indexOf('?')) {
    let paramContent = url.split('?')[1]; // 获取?之后的参数字符串
    let paramsArray = [];
    if (paramContent) {
      paramsArray = paramContent.split('&');// 参数字符串分割为数组
      // 遍历数组，拿到json对象
      paramsArray.forEach((item, index, paramsArray) => {
        paramResult[paramsArray[index].split('=')[0]] = paramsArray[index].split('=')[1];
      });
    }
  }
  return paramResult;
}
export function getMimeTypeBySuffix(suffix) {
  let mimeType = '';
  switch (suffix.toLowerCase()) {
    case 'html': mimeType = 'text/html';
      break;
    case 'txt': mimeType = 'text/plain';
      break;
    case 'gif': mimeType = 'image/gif';
      break;
    case 'jpeg': mimeType = 'image/jpeg';
      break;
    case 'jpg': mimeType = 'image/jpeg';
      break;
    case 'png': mimeType = 'image/png';
      break;
    case 'mp4': mimeType = 'video/mp4';
      break;
    case 'mpg': mimeType = 'video/mpeg';
      break;
    case 'mpeg': mimeType = 'video/mpeg';
      break;
    case 'avi': mimeType = 'video/x-msvideo';
      break;
    case 'gz': mimeType = 'application/x-gzip';
      break;
    case 'tar': mimeType = 'application/x-tar';
      break;
    case 'doc': mimeType = 'application/msword';
      break;
    case 'docx': mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'xls': mimeType = 'application/vnd.ms-excel';
      break;
    case 'xlsx': mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      break;
    case 'ppt': mimeType = 'application/vnd.ms-powerpoint';
      break;
    case 'pptx': mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      break;
    case 'gzip': mimeType = 'application/x-gzip';
      break;
    case 'zip': mimeType = 'application/zip';
      break;
    case '7zip': mimeType = 'application/zip';
      break;
    case 'rar': mimeType = 'application/rar';
      break;
    case 'pdf': mimeType = 'application/pdf';
      break;
  }
  return mimeType;
}

function getMarkdownTableCells(line) {
  const trimmed = String(line || '').trim();
  const normalized = trimmed.replace(/｜/g, '|').replace(/^\|/, '').replace(/\|$/, '');
  return normalized.split('|').map(cell => cell.trim());
}

function isMarkdownTableSeparator(line) {
  const cells = getMarkdownTableCells(line);
  return cells.length > 1 && cells.every(cell => /^:?-{3,}:?$/.test(cell));
}

function isMarkdownTableRow(line) {
  const trimmed = String(line || '').trim();
  return /[|｜]/.test(trimmed) && getMarkdownTableCells(trimmed).length > 1;
}

function renderTable(headerCells, rows) {
  const columnCount = headerCells.length || (rows[0] ? rows[0].length : 0);
  const thStyle = 'padding: 6px 4px; border: 1px solid #e9e5f4; background: #f6f3ff; color: #655a82; font-weight: 600; text-align: left; white-space: normal; word-break: break-word; overflow-wrap: anywhere;';
  const tdStyle = 'padding: 6px 4px; border: 1px solid #e9e5f4; color: #444; vertical-align: top; white-space: normal; word-break: break-word; overflow-wrap: anywhere;';
  const tableStyle = 'width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; line-height: 1.45;';
  const wrapperStyle = 'width: 100%; margin: 8px 0; border-radius: 8px;';
  const thead = headerCells.length
    ? `<thead><tr>${headerCells.map(cell => `<th style="${thStyle}">${cell}</th>`).join('')}</tr></thead>`
    : '';
  const tbody = rows.length
    ? `<tbody>${rows.map(row => `<tr>${Array.from({length: columnCount}, (_, index) => `<td style="${tdStyle}">${row[index] || ''}</td>`).join('')}</tr>`).join('')}</tbody>`
    : '';
  return `<div class="ai-markdown-table-wrapper" style="${wrapperStyle}"><table style="${tableStyle}">${thead}${tbody}</table></div>`;
}

function renderMarkdownTable(headerLine, bodyLines) {
  return renderTable(
    getMarkdownTableCells(headerLine),
    bodyLines.map(row => getMarkdownTableCells(row))
  );
}

function getInferredTableHeaders(lines, rowIndex, columnCount) {
  const nearbyContext = lines.slice(Math.max(0, rowIndex - 3), rowIndex).join(' ');
  if (/近期动态详情/.test(nearbyContext) && columnCount === 5) {
    return ['客户', '机构', '动态类型', '近期动态', '日期'];
  }
  if (/recent\s+(?:updates?|activity)\s+details/i.test(nearbyContext) && columnCount === 5) {
    return ['Customer', 'Institution', 'Update type', 'Recent update', 'Date'];
  }
  return [];
}

function renderMarkdownTables(text) {
  const lines = String(text || '').split(/\r?\n/);
  const output = [];

  for (let i = 0; i < lines.length; i++) {
    if (
      i + 1 < lines.length &&
      isMarkdownTableRow(lines[i]) &&
      isMarkdownTableSeparator(lines[i + 1])
    ) {
      const headerLine = lines[i];
      const bodyLines = [];
      i += 2;
      while (i < lines.length && isMarkdownTableRow(lines[i]) && !isMarkdownTableSeparator(lines[i])) {
        bodyLines.push(lines[i]);
        i += 1;
      }
      i -= 1;
      output.push(renderMarkdownTable(headerLine, bodyLines));
    } else if (isMarkdownTableRow(lines[i]) && !isMarkdownTableSeparator(lines[i])) {
      const rowIndex = i;
      const columnCount = getMarkdownTableCells(lines[i]).length;
      const rows = [];
      while (
        i < lines.length &&
        isMarkdownTableRow(lines[i]) &&
        !isMarkdownTableSeparator(lines[i]) &&
        getMarkdownTableCells(lines[i]).length === columnCount
      ) {
        rows.push(getMarkdownTableCells(lines[i]));
        i += 1;
      }

      if (rows.length >= 2 && columnCount >= 3) {
        const headerCells = getInferredTableHeaders(lines, rowIndex, columnCount);
        output.push(renderTable(headerCells, rows));
        i -= 1;
      } else {
        output.push(lines[rowIndex]);
        i = rowIndex;
      }
    } else {
      output.push(lines[i]);
    }
  }

  return output.join('\n');
}

const BAILIAN_DOCUMENT_HOSTS = new Set([
  'dashscope-file-datacenter-prod-01.oss-cn-beijing.aliyuncs.com',
]);
const BAILIAN_DOCUMENT_PATH_PATTERN = /\.(?:pdf|ppt|pptx)$/i;
const SOURCE_LINK_EXPIRY_BUFFER_MS = 60 * 1000;

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatSourceLinkExpiry(timestamp) {
  const date = new Date(timestamp);
  const pad = value => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function getBailianDocumentLink(rawUrl) {
  try {
    const url = new URL(rawUrl);
    const expires = url.searchParams.get('Expires');
    const accessKeyId = url.searchParams.get('OSSAccessKeyId');
    const signature = url.searchParams.get('Signature');

    if (
      url.protocol !== 'https:' ||
      !BAILIAN_DOCUMENT_HOSTS.has(url.hostname.toLowerCase()) ||
      !BAILIAN_DOCUMENT_PATH_PATTERN.test(url.pathname) ||
      !expires ||
      !/^\d+$/.test(expires) ||
      !accessKeyId ||
      !signature
    ) {
      return null;
    }

    const expiresAt = Number(expires) * 1000;
    if (!Number.isFinite(expiresAt)) {
      return null;
    }

    const extension = url.pathname.match(/\.([^.]+)$/)?.[1]?.toLowerCase();
    const fileType = extension === 'pdf' ? 'PDF' : 'PPT';
    const encodedFileName = url.pathname.split('/').pop();
    let fileName = encodedFileName;
    try {
      fileName = decodeURIComponent(encodedFileName);
    } catch (e) {
      // Keep the encoded filename when it contains malformed escape sequences.
    }

    return {
      extension,
      expiresAt,
      fileName,
      fileType,
      isExpired: Date.now() >= expiresAt - SOURCE_LINK_EXPIRY_BUFFER_MS,
      url: rawUrl,
    };
  } catch (e) {
    return null;
  }
}

export function getActiveBailianDocumentLink(rawUrl) {
  const documentLink = getBailianDocumentLink(rawUrl);
  return documentLink && !documentLink.isExpired ? documentLink : null;
}

function expiredSourceDocumentLinkHtml(label) {
  return `<span class="ai-source-document-expired" aria-label="${escapeHtml(`${label}，已失效`)}" style="color: #888; font-weight: 400; cursor: default; text-decoration: none; word-break: break-word;">${escapeHtml(label)}（已失效）</span>`;
}

function sourceDocumentLinkHtml(label, link) {
  const safeLabel = escapeHtml(label);
  const safeUrl = escapeHtml(link.url);
  const expiresAt = formatSourceLinkExpiry(link.expiresAt);
  const buttonText = `${link.fileType}原文`;
  const isGenericDownloadLabel = /^(?:(?:点击)?下载|download)(?:\s*(?:pdf|pptx?|文件|document|链接|link))?$/i.test(String(label || '').trim());
  const previewFileName = isGenericDownloadLabel
    ? link.fileName
    : BAILIAN_DOCUMENT_PATH_PATTERN.test(String(label || '').trim())
      ? String(label).trim()
      : `${String(label).trim()}.${link.extension}`;
  const labelHtml = isGenericDownloadLabel
    ? ''
    : `<span style="color: #aa341b; font-weight: 500; word-break: break-word;">${safeLabel}</span>`;
  const buttonMargin = isGenericDownloadLabel ? '0' : '8px';
  const ariaLabel = isGenericDownloadLabel
    ? `${buttonText}，链接有效至 ${expiresAt}`
    : `${buttonText}：${label}，链接有效至 ${expiresAt}`;
  const safeAriaLabel = escapeHtml(ariaLabel);
  const safePreviewFileName = escapeHtml(previewFileName);

  return `<span class="ai-source-document" style="display: inline-flex; align-items: center; flex-wrap: wrap; max-width: 100%;">${labelHtml}<a class="ai-source-document-link" href="${safeUrl}" target="_blank" rel="noopener noreferrer" referrerpolicy="no-referrer" data-source-file-name="${safePreviewFileName}" data-source-expires-at="${link.expiresAt}" aria-label="${safeAriaLabel}" style="display: inline-flex; align-items: center; max-width: 100%; margin-left: ${buttonMargin}; padding: 3px 8px; box-sizing: border-box; color: #aa341b; background: rgba(170, 52, 27, 0.08); border: 1px solid rgba(170, 52, 27, 0.22); border-radius: 12px; font-size: 12px; font-weight: 500; line-height: 1.4; text-decoration: none; white-space: normal; word-break: break-word; overflow-wrap: anywhere;"><svg aria-hidden="true" viewBox="0 0 24 24" width="13" height="13" style="flex-shrink: 0; margin-right: 4px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;"><path d="M14 3h7v7"></path><path d="M10 14 21 3"></path><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5"></path></svg><span>${buttonText}</span></a><span class="ai-source-document-expiry" style="max-width: 100%; margin-top: 3px; color: #888; font-size: 11px; line-height: 1.4; white-space: normal; word-break: break-word; overflow-wrap: anywhere;">链接有效至 ${expiresAt}</span></span>`;
}

export function formatMessage(text) {
  if (!text) return '';
  let formatted = text;
  const sourceDocumentLinks = [];
  const visitLinkHtml = (visitId) => `<span class="visit-link-btn" style="display: inline-flex; align-items: center; color: #aa341b; font-weight: bold; cursor: pointer; background: rgba(170, 52, 27, 0.1); padding: 4px 10px; border-radius: 15px; border: 1px solid rgba(170, 52, 27, 0.2); margin: 4px 0; font-size: 13px;" onclick="window.handleVisitClick && window.handleVisitClick('${visitId}')">点击前往拜访 / Go to Visit</span>`;
  const meetingLinkHtml = (meetingId) => `<span class="visit-link-btn" style="display: inline-flex; align-items: center; color: #aa341b; font-weight: bold; cursor: pointer; background: rgba(170, 52, 27, 0.1); padding: 4px 10px; border-radius: 15px; border: 1px solid rgba(170, 52, 27, 0.2); margin: 4px 0; font-size: 13px;" onclick="window.handleVisitClick && window.handleVisitClick('${meetingId}')">点击前往会议 / Go to Meeting</span>`;

  // Support visit IDs returned as a bare bracket token when the same line has visit context.
  formatted = formatted.replace(/((?:拜访|Visit)[^\r\n【】]{0,80})【\s*([a-zA-Z0-9_-]{8,})\s*】/gi, (match, prefix, visitId) => `${prefix}${visitLinkHtml(visitId)}`);
  formatted = formatted.replace(/【\s*([a-zA-Z0-9_-]{8,})\s*】([^\r\n【】]{0,80}(?:拜访|Visit))/gi, (match, visitId, suffix) => `${visitLinkHtml(visitId)}${suffix}`);

  // Support Headers
  formatted = formatted.replace(/^####\s*(.*$)/gm, '<h4 style="margin: 8px 0; font-size: 14px; font-weight: bold;">$1</h4>');
  formatted = formatted.replace(/^###\s*(.*$)/gm, '<h3 style="margin: 10px 0; font-size: 16px; font-weight: bold;">$1</h3>');
  formatted = formatted.replace(/^##\s*(.*$)/gm, '<h2 style="margin: 12px 0; font-size: 18px; font-weight: bold; color: #333;">$1</h2>');
  formatted = formatted.replace(/^#\s*(.*$)/gm, '<h1 style="margin: 12px 0; font-size: 20px; font-weight: bold; color: #333;">$1</h1>');

  // Support Horizontal Rule
  formatted = formatted.replace(/^---$/gm, '<hr style="border: 0; border-top: 1px solid #eee; margin: 12px 0;">');

  // Support Blockquotes
  formatted = formatted.replace(/^> (.*$)/gm, '<blockquote style="margin: 8px 0; padding-left: 10px; border-left: 3px solid #ddd; color: #666;">$1</blockquote>');

  // Support Bold **text**
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong style="font-weight: bold;">$1</strong>');

  // Only active, signed Bailian PDF/PPT links can open. Expired links are clearly display-only.
  formatted = formatted.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, label, rawUrl) => {
    const documentLink = getBailianDocumentLink(rawUrl);
    if (!documentLink) {
      return `<span style="color: #aa341b; font-weight: 500;">${escapeHtml(label)}</span>`;
    }
    if (documentLink.isExpired) {
      return expiredSourceDocumentLinkHtml(label);
    }

    const token = `%%__AI_SOURCE_DOCUMENT_${sourceDocumentLinks.length}__%%`;
    sourceDocumentLinks.push({
      html: sourceDocumentLinkHtml(label, documentLink),
      token,
    });
    return token;
  });

  // Support Raw URLs - Shorten to last path segment
  formatted = formatted.replace(/(https?:\/\/[^\s<]+)/g, (match) => {
    try {
      let cleanUrl = match;
      let suffix = '';
      // Strip common trailing punctuation
      const trailing = cleanUrl.match(/[.,;!?)]+$/);
      if (trailing) {
        suffix = trailing[0];
        cleanUrl = cleanUrl.slice(0, -suffix.length);
      }

      const urlObj = new URL(cleanUrl);
      const path = urlObj.pathname;
      // Use last segment of path, or hostname if path is empty
      const segments = path.split('/').filter(s => s);
      let label = segments.length > 0 ? segments[segments.length - 1] : urlObj.hostname;

      try {
        label = decodeURIComponent(label);
      } catch (e) {
        // ignore
      }

      return `<span style="color: #aa341b; font-weight: 500;">${label}</span>${suffix}`;
    } catch (e) {
      return match;
    }
  });

  // Support Markdown tables
  formatted = renderMarkdownTables(formatted);

  // Support Lists
  // 1. Bullet • (Level 1 / Section Header style)
  formatted = formatted.replace(/^\s*•\s+(.*$)/gm, '<div style="margin-top: 4px; font-weight: 500; color: #333; display: flex; align-items: flex-start;"><span style="margin-right: 6px; color: #aa341b; line-height: 1.5;">•</span><div style="flex: 1; line-height: 1.5;">$1</div></div>');

  // 2. Dash - (Level 2 / Detail Item style)
  formatted = formatted.replace(/^\s*-\s+(.*$)/gm, '<div style="padding-left: 2px; margin-top: 0; display: flex; align-items: baseline;"><span style="margin-right: 8px; color: #999; font-size: 0.4em; position: relative; top: -2px;">●</span><div style="flex: 1; color: #555; line-height: 1.5;">$1</div></div>');

  // Remove newline after list item divs to prevent extra spacing
  formatted = formatted.replace(/<\/div>\r?\n/g, '</div>');

  // Handle Paragraphs and Line Breaks
  formatted = formatted.replace(/\n\s*\n/g, '<br>');
  formatted = formatted.replace(/\n/g, '<br>');

  // Support References like <ref> or [^1]
  formatted = formatted.replace(/<ref>(.*?)<\/ref>/g, '<span class="ref-tag" style="color: #aa341b; font-weight: bold; margin: 0 2px; font-size: 0.9em; vertical-align: super;">$1</span>');
  formatted = formatted.replace(/\[\^(\d+)\]/g, '<span class="ref-tag" style="color: #aa341b; font-weight: bold; margin: 0 2px; font-size: 0.9em; vertical-align: super;">[$1]</span>');

  // Support visit ID links
  formatted = formatted.replace(/【(?:拜访ID|Visit ID)\s*[:：]\s*([a-zA-Z0-9_-]+)】/gi, (match, visitId) => visitLinkHtml(visitId));
  formatted = formatted.replace(/【(?:会议ID|Meeting ID)\s*[:：]\s*([a-zA-Z0-9_-]+)】/gi, (match, meetingId) => meetingLinkHtml(meetingId));

  sourceDocumentLinks.forEach(({ token, html }) => {
    formatted = formatted.split(token).join(html);
  });

  return formatted;
}
